// import { Link as RouterLink } from "react-router-dom";
// material
import { LoadingButton } from "@mui/lab";
import { styled } from "@mui/material/styles";
import {
  Card,
  Stack,
  // Link,
  Container,
  Typography,
} from "@mui/material";

// import { getAuth, getRedirectResult } from "firebase/auth";
import platform from "platform-detect";
import { useCallback, useEffect, useState } from "react";
import { connect } from "react-redux";
import { useNavigate } from "react-router";

import { ROUTES } from "../../commons";
import { authProvider } from "../../models/auth";

// layouts
// import AuthLayout from "../../layouts/AuthLayout";
// components
import Page from "../elements/Page";
import { MHidden } from "../@material-extend";
// import { LoginForm } from "../elements/authentication/login";
// import AuthSocial from "../elements/authentication/AuthSocial";

import ImgLogin from "../../images/illustrations/illustration_login.png";

// ----------------------------------------------------------------------

const RootStyle = styled(Page)(({ theme }) => ({
  [theme.breakpoints.up("md")]: {
    display: "flex",
  },
}));

const SectionStyle = styled(Card)(({ theme }) => ({
  width: "100%",
  maxWidth: 464,
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  margin: theme.spacing(2, 0, 2, 2),
}));

const ContentStyle = styled("div")(({ theme }) => ({
  maxWidth: 480,
  margin: "auto",
  display: "flex",
  minHeight: "100vh",
  flexDirection: "column",
  justifyContent: "center",
  padding: theme.spacing(12, 0),
}));

// ----------------------------------------------------------------------

const Signin = ({ isAuthenticated, authenticate }) => {
  const navigate = useNavigate();

  const [isSubmitting, toggleSubmitting] = useState(false);

  const postRedirectAuth = useCallback(async () => {
    // const result = await getRedirectResult(getAuth());
    // console.debug({ result });
    const next = new URLSearchParams(document.location.search).get("next");
    navigate(next || ROUTES.Root, { replace: true });
  }, [navigate]);

  const startPopupMrlogin = useCallback(async () => {
    const searchParams = new URLSearchParams();
    searchParams.append("client_id", process.env.REACT_APP_MRLOGIN_CLIENT_ID);
    searchParams.append(
      "redirect_uri",
      `${document.location.origin}${ROUTES.CallbacksMrlogin}`
    );

    toggleSubmitting(true);

    try {
      window.open(
        `https://mrlogin.io/login?${searchParams.toString()}`,
        "click-mrlogin",
        "width=500, height=600"
      );
    } catch (err) {
      console.error(JSON.stringify(err));
    }
  }, []);

  // const srcMrLogin = useMemo(() => {
  //   const searchParams = new URLSearchParams();
  //   searchParams.append("client_id", process.env.REACT_APP_MRLOGIN_CLIENT_ID);
  //   searchParams.append(
  //     "redirect_uri",
  //     `${document.location.origin}${ROUTES.CallbacksMrlogin}`
  //   );
  //   return `https://mrlogin.io/login?${searchParams.toString()}`;
  // }, []);

  useEffect(() => {
    console.log({ isAuthenticated });
    if (isAuthenticated) {
      postRedirectAuth();
    }
  }, [isAuthenticated, postRedirectAuth]);

  useEffect(() => {
    const onMessage = (e) => {
      if (document.location.origin === e.origin) {
        switch (e.data.type) {
          case "signin-success":
            if (platform.safari) {
              document.location.reload();
            } else {
              authenticate();
            }
            break;

          case "session":
            const { accessToken, refreshToken } = e.data;
            authProvider.login({ accessToken, refreshToken });

            (async () => {
              if (!(await authenticate())) {
                alert("관계자외 출입금지");
              }
            })();
            break;

          default: // Nothing
        }
      }
    };

    window.addEventListener("message", onMessage);

    return () => {
      window.removeEventListener("message", onMessage);
    };
  }, [authenticate]);

  return (
    <RootStyle title="Sign in :: Click">
      {/* <AuthLayout>
        Don’t have an account? &nbsp;
        <Link
          underline="none"
          variant="subtitle2"
          component={RouterLink}
          to="/register"
        >
          Get started
        </Link>
      </AuthLayout> */}

      <MHidden width="mdDown">
        <SectionStyle>
          <Typography variant="h3" sx={{ px: 5, mt: 10, mb: 5 }}>
            Hi, Welcome Back
          </Typography>
          <img src={ImgLogin} alt="login" />
        </SectionStyle>
      </MHidden>

      <Container maxWidth="sm">
        <ContentStyle>
          <Stack sx={{ mb: 5 }}>
            <Typography variant="h4" gutterBottom>
              Sign in to Click AdminSite
            </Typography>
            {/* <Typography sx={{ color: "text.secondary" }}>
              Enter your details below.
            </Typography> */}
          </Stack>

          {/* {platform.safari ? ( */}
          <LoadingButton
            fullWidth
            size="large"
            type="submit"
            variant="contained"
            loading={isSubmitting}
            onClick={startPopupMrlogin}
          >
            Sign in
          </LoadingButton>
          {/* ) : (
            <iframe src={srcMrLogin} height={420} title="mrlogin" />
          )} */}

          {/* <AuthSocial />

          <LoginForm />

          <MHidden width="smUp">
            <Typography variant="body2" align="center" sx={{ mt: 3 }}>
              Don’t have an account?&nbsp;
              <Link variant="subtitle2" component={RouterLink} to="register">
                Get started
              </Link>
            </Typography>
          </MHidden> */}
        </ContentStyle>
      </Container>
    </RootStyle>
  );
};

const mapState = ({ auth: { isAuthenticated } }) => ({
  isAuthenticated,
});
const mapDispatch = ({ auth: { authenticate } }) => ({ authenticate });

export default connect(mapState, mapDispatch)(Signin);
